/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

var baseTableProps = {
  allowResizeColumnWidth: {
    type: Boolean,
    "default": void 0
  },
  bordered: Boolean,
  bottomContent: {
    type: [String, Function]
  },
  cellEmptyContent: {
    type: [String, Function]
  },
  columns: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  data: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  disableDataPage: Boolean,
  empty: {
    type: [String, Function],
    "default": ""
  },
  firstFullRow: {
    type: [String, Function]
  },
  fixedRows: {
    type: Array
  },
  footData: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  footerAffixProps: {
    type: Object
  },
  footerAffixedBottom: {
    type: [Boolean, Object],
    "default": false
  },
  footerSummary: {
    type: [String, Function]
  },
  headerAffixProps: {
    type: Object
  },
  headerAffixedTop: {
    type: [Boolean, Object],
    "default": false
  },
  height: {
    type: [String, Number]
  },
  horizontalScrollAffixedBottom: {
    type: [Boolean, Object]
  },
  hover: Boolean,
  lastFullRow: {
    type: [String, Function]
  },
  loading: {
    type: [Boolean, Function],
    "default": void 0
  },
  loadingProps: {
    type: Object
  },
  maxHeight: {
    type: [String, Number]
  },
  pagination: {
    type: Object
  },
  paginationAffixedBottom: {
    type: [Boolean, Object]
  },
  resizable: Boolean,
  rowAttributes: {
    type: [Object, Array, Function]
  },
  rowClassName: {
    type: [String, Object, Array, Function]
  },
  rowKey: {
    type: String,
    "default": "id",
    required: true
  },
  rowspanAndColspan: {
    type: Function
  },
  rowspanAndColspanInFooter: {
    type: Function
  },
  scroll: {
    type: Object
  },
  size: {
    type: String,
    "default": "medium",
    validator: function validator(val) {
      if (!val) return true;
      return ["small", "medium", "large"].includes(val);
    }
  },
  stripe: Boolean,
  tableContentWidth: {
    type: String,
    "default": ""
  },
  tableLayout: {
    type: String,
    "default": "fixed",
    validator: function validator(val) {
      if (!val) return true;
      return ["auto", "fixed"].includes(val);
    }
  },
  topContent: {
    type: [String, Function]
  },
  verticalAlign: {
    type: String,
    "default": "middle",
    validator: function validator(val) {
      if (!val) return true;
      return ["top", "middle", "bottom"].includes(val);
    }
  },
  onCellClick: Function,
  onPageChange: Function,
  onRowClick: Function,
  onRowDblclick: Function,
  onRowMousedown: Function,
  onRowMouseenter: Function,
  onRowMouseleave: Function,
  onRowMouseover: Function,
  onRowMouseup: Function,
  onScroll: Function,
  onScrollX: Function,
  onScrollY: Function
};

export { baseTableProps as default };
//# sourceMappingURL=base-table-props.js.map
